/* eslint-disable i18next/no-literal-string */
import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { DocRenderer, IStyledProps } from 'react-doc-viewer';
import styledComponent from 'styled-components';
import { base64DocumentToURL } from 'app/helpers/fileHelper';

const removePdfBase64Prefix = (str: string): string => {
  const prefix = 'data:application/pdf; base64,';
  const prefix2 = 'data:application/pdf;base64,';

  if (str?.startsWith(prefix)) {
    return str?.slice(prefix.length);
  }
  if (str?.startsWith(prefix2)) {
    return str?.slice(prefix2.length);
  }

  return str;
};

const PDFRenderer: DocRenderer = ({ mainState: { currentDocument } }) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!currentDocument) return;

    const { url, dispose } = base64DocumentToURL(removePdfBase64Prefix(currentDocument?.fileData as string));
    setPdfUrl(url);

    return () => {
      dispose();
    };
  }, [currentDocument]);

  if (!currentDocument || !pdfUrl) return null;

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;

  return (
    <Container id="pdf-renderer">
      <Document file={pdfUrl} loading={<span>Loading...</span>} onLoadError={(e) => {console.log(e)}} onSourceError={(e) => {console.log(e)}}>
        {Array.from(new Array(1), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} />
        ))}
      </Document>
    </Container>
  );
};

export default PDFRenderer;

PDFRenderer.fileTypes = ['pdf', 'application/pdf'];
PDFRenderer.weight = 0;


const Container = styledComponent.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  width: 100%;

  .react-pdf__Page__canvas {
    left: 0px;
  }

  /* width */
  &::-webkit-scrollbar {
    ${(props: IStyledProps) => {
      return props.theme.disableThemeScrollbar ? '' : 'width: 10px';
    }};
  }
  /* Track */
  &::-webkit-scrollbar-track {
    /* background: ${(props: IStyledProps) => props.theme.secondary}; */
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${(props: IStyledProps) => props.theme.tertiary};
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: ${(props: IStyledProps) => props.theme.primary};
  }
`;
